<template>
    <div>
        <h2 class="titulo">ASSINATURA OBRIGATÓRIA</h2>
        <v-layout wrap class="justify-center">
            <div class="d-flex justify-center">
                <h5 class="primary--text">Para prosseguir aguarde a assinatura do contrato</h5>
            </div>
            <v-flex xs12 md10>
                <div class="mx-1 mt-3 mb-5">
                    <dados-da-compra :pedido="pedido" :desconto="desconto" :permite-flavor-todos-produtos="!!permite_flavor_todos_produtos" :administradora="administradora" :seguro="seguro" :aguardando-pagamento-cliente="AguardandoPagamentoCliente" />
                </div>
                <div>
                    <v-row class="pb-3 justify-space-between">
                        <v-col class="d-flex align-center">
                            <h2 class="primary--text">Dados do Contrato</h2>
                        </v-col>
                    </v-row>
                    <v-divider />
                    <v-layout class="mx-1 mt-3 mb-5">
                        <v-flex xs12 md8>
                            <v-icon class="align-self-center" color="primary">{{ getIconStatusContrato(pedido.contrato.status) }}</v-icon>
                            <label class="align-self-center" style="margin-left: 5px;font-weight: bold;">Status do contrato: {{ getDescricaoStatusContrato(pedido.contrato.status,pedido.docusign_falha,pedido.docusign_enviado) }}</label>
                        </v-flex>
                        <v-flex xs12 md4>
                            <v-btn v-if="pedido.contrato.status === StatusContrato.ContratoPendente" id="ButtonProsseguir" block color="primary"
                                   @click="reenviarContrato" style="margin-right: 0;">
                                Reenviar Contrato
                            </v-btn>
                        </v-flex>
                    </v-layout>
                    <v-row class="pb-3 justify-space-between">
                    </v-row>
                </div>
                <v-layout row-padding class="justify-space-between" style="margin-top: 40px">
                    <v-flex class="col">
                        <v-btn id="ButtonVoltar" block color="secondary" @click="voltar()" style="margin-left: 0;">Voltar</v-btn>
                    </v-flex>
                    <v-flex class="col" style="margin-top: -20px">
                        <div class="tooltip-icon">
                            <v-layout wrap>
                                <div class="tooltip-descricao v-card transition" style="width: 300px; margin-left: 20px; margin-top: -50px; padding: 5px;">
                                    <p>O botão será habilitado assim que o contrato for assinado pelo cliente.</p>
                                </div>
                                <v-icon size="18" color="primary">mdi-help-box</v-icon>
                            </v-layout>
                        </div>
                        <v-btn class="ButtonProsseguir" id="ButtonProsseguir" block color="primary" :disabled="pedido.contrato.status !== StatusContrato.ContratoAssinado && pedido.assinatura_obrigatoria"
                               @click="finalizar()">
                            prosseguir com a venda
                        </v-btn>
                    </v-flex>
                </v-layout>
            </v-flex>
        </v-layout>
    </div>
</template>

<script>

  import { notification, trimZeros, getDescricaoStatusContrato } from '@/plugins/helpers'
  import { StatusContrato, StatusPedido, TipoPessoa } from '@/plugins/constants'
  import reenviarContratoMixin from '@/mixins/reenviarContratoMixin'
  import { icones_status_hashmap } from '../../../plugins/listaStatusStyles'
  import { pedido_default } from '../../../plugins/pedido_default'
  import DadosDaCompra from '../../../fragments/InformacoesProposta/DadosDaCompra.vue'
  import telefonesMixin from '@/mixins/telefonesMixin'
  export default {
    name: 'AssinaturaContrato',
    components: { DadosDaCompra },
    mixins: [reenviarContratoMixin, telefonesMixin],
    props: { value: Object },
    data: () => ({
      desconto: false,
      pedido: pedido_default,
      assinatura_obrigatoria_grupos_pontuais: false,
      assinatura_obrigatoria_grupos_convencionais: false,
      exibe_reenvio_whatsapp: false,
      id_pedido: 0
    }),
    computed: {
      StatusPedido: () => StatusPedido,
      StatusContrato: () => StatusContrato
    },
    async mounted () {
      this.exibe_reenvio_whatsapp = this.$session.get('exibe_reenvio_whatsapp')
      if (this.value > 0) {
        await this.getPedido()
      }
      await this.loadConfiguracao()
    },
    methods: {
      getDescricaoStatusContrato,
      reload (reload) {
        this.$emit('reload', reload)
      },
      async getPedido () {
        await this.$http.get(`/vendas/${this.value}`)
          .then(res => {
            this.desconto = res.data.desconto
            res.data.bem = { ...this.pedido.bem, ...res.data.bem }
            res.data.grupo = { ...this.pedido.grupo, ...res.data.grupo }
            res.data.plano = { ...this.pedido.plano, ...res.data.plano }
            this.pedido = { ...this.pedido, ...res.data }
          })
          .catch(err => notification('error', err, 'Não foi possível buscar a venda.'))
      },
      isPessoaFisica () {
        return this.pedido.cliente.pessoa === TipoPessoa.Fisica
      },
      getTelefone () {
        return this.getTelefone(this.pedido.cliente, this.pedido.cliente.instancia_cliente)
      },
      cliente () {
        return (this.isPessoaFisica() ? this.pedido.cliente.nome_completo : this.pedido.cliente_pedido.razao_social) || '-'
      },
      getIconStatusContrato (status) {
        if (icones_status_hashmap[status]) {
          return icones_status_hashmap[status]
        }
        return 'work_off'
      },
      trimZeros,
      reenviarContrato () {
        this.showDialogReenviaContrato(this.pedido.contrato.id_contrato, this.pedido.whatsapp, this.exibe_reenvio_whatsapp)
      },
      salvar () {
        if (this.formularioValido()) {
          this.$http.post(`/dadosbancarios`, this.pedido)
            .then(res => {
              if (res.data.devolucao) {
                this.pedido.dados_bancarios.devolucao = { ...this.pedido.dados_bancarios.devolucao, ...res.data.devolucao }
              }
              if (res.data.debito) {
                this.pedido.dados_bancarios.debito_conta = { ...this.pedido.dados_bancarios.debito_conta, ...res.data.debito }
              }
              this.$http.get(`/vendas/assinaturaobrigatoria/${this.pedido.id_pedido}`)
                .then(res => {
                  this.pedido.assinatura_obrigatoria = res.data.ok

                  this.$emit('input', this.pedido)
                  this.$emit('nextPage')
                })
                .catch(err => notification('error', err, 'Não foi possível buscar informações do pedido'))
            })
            .catch(err => notification('error', err, 'Não foi possível salvar os dados bancários'))
        }
      },
      voltar () {
        this.$emit('finalizado')
        this.$router.push({ name: 'minhas-vendas' })
      },
      finalizar () {
        const tela = 'selecionar_assinatura'
        this.$router.push({ name: 'cadastro', params: { pedido: this.pedido, tela } })
        this.$emit('input', this.pedido)
        this.$emit('nextPage')
      },
      async loadConfiguracao () {
        await this.$http.get('/configuracao/get')
          .then(result => {
            if (result.data) {
              this.assinatura_obrigatoria_grupos_pontuais = result.data.assinatura_obrigatoria_grupos_pontuais
              this.assinatura_obrigatoria_grupos_convencionais = result.data.assinatura_obrigatoria_grupos_convencionais
            }
          })
          .catch(err => notification('error', err, 'Não foi possível buscar a configuração!'))
      }
    }
  }
</script>

<style scoped type="scss">
.tooltip-descricao {
    position:absolute;
    background: #FFF;
    opacity: 0;
}
.tooltip-icon:hover .tooltip-descricao {
    opacity: 1;
    z-index: 0;
}
label {
    font-size: 1rem;
    color: var(--darkgray);
}

p {
    color: var(--dark);
    font-size: 1.1rem;
}
</style>
